export default __webpack_public_path__ + "static/media/hospitalizationCardArrow.28427639.svg";